<template>
  <div>
    <b-modal
      :id="`modal-pay-doctor`"
      :no-close-on-backdrop="true"
      :title="$t('surgery.pay-doctor')"
      ok-only
      :ok-title="$t('surgery.pay-doctor')"
      @ok="payDoctorPrice()"
    >
      <b-card-text>
        <h5>{{ $t("surgery.pay-doctor") }}</h5>
        {{
          $t("surgery.Are you sure do you want to pay doctor for this surgery")
        }}
      </b-card-text>
    </b-modal>
    <b-modal
      :id="`modal-pay-selected-items`"
      :no-close-on-backdrop="true"
      :title="$t('surgery.pay-selected')"
      ok-only
      :ok-title="$t('surgery.pay-doctor')"
      @ok="paySelectedItems()"
    >
      <b-card-text>
        <h5>{{ $t("surgery.pay-selected") }}</h5>
        {{ $t("surgery.pay-selected-items-confirmation") }}
        <div class="mt-2">
          <div>
            {{ $t("common.selected-items") }}: {{ selectedItems.length }}
          </div>
          <div>
            {{ $t("hospital.doctorTotalPrices") }}:
            {{ formatIQDCurrency(selectedItemsTotalPrice) }}
          </div>
          <div>
            {{ $t("surgery.doctor_price") }}:
            {{ formatIQDCurrency(selectedItemsTotalDoctorPrice) }}
          </div>
          <h4>
            {{ $t("hospital.doctorTotalAfterDiscount") }}:
            {{ formatIQDCurrency(selectedItemsNetTotal) }}
          </h4>
        </div>
      </b-card-text>
    </b-modal>
    <b-modal
      :id="`modal-pay-doctor-stay`"
      :no-close-on-backdrop="true"
      :title="$t('surgery.pay-doctor')"
      ok-only
      :ok-title="$t('surgery.pay-doctor')"
      @ok="payDoctorForStay()"
    >
      <b-card-text>
        <h5>{{ $t("surgery.pay-doctor") }}</h5>
        {{
          $t(
            "surgery.Are you sure do you want to pay doctor for this patient stay"
          )
        }}
      </b-card-text>
    </b-modal>
    <b-modal
      :id="`modal-pay-doctor-consultancies`"
      :no-close-on-backdrop="true"
      :title="$t('surgery.pay-doctor')"
      ok-only
      :ok-title="$t('surgery.pay-doctor')"
      @ok="payConsultancies()"
    >
      <b-card-text>
        <h5>{{ $t("surgery.pay-doctor") }}</h5>
        {{
          $t(
            "surgery.Are you sure do you want to pay doctor for this consultancy"
          )
        }}
      </b-card-text>
    </b-modal>
    <!-- ReDistribution Modal -->
    <b-modal
      id="modal-redistribution"
      :no-close-on-backdrop="true"
      :title="$t('accounting.reDistribution')"
      :ok-title="$t('common.confirm')"
      :cancel-title="$t('common.cancel')"
      @ok="confirmReDistribution()"
      @cancel="cancelReDistribution()"
    >
      <b-card-text>
        <h5>{{ $t("accounting.reDistribution") }}</h5>
        <p>{{ $t("accounting.reDistribution-confirmation") }}</p>
        <b-form-group
          :label="$t('accounting.reason')"
          label-for="redistribution-reason"
        >
          <b-form-textarea
            id="redistribution-reason"
            v-model="redistributionReason"
            :placeholder="$t('accounting.reason-placeholder')"
            rows="3"
            required
          />
        </b-form-group>
      </b-card-text>
    </b-modal>
    <!-- Account Statement Modal -->
    <b-modal
      id="modal-account-statement"
      :title="$t('hospital.doctor-account-statement')"
      size="xl"
      hide-footer
      @hide="closeAccountStatementModal"
    >
      <div
        v-if="loadingAccountStatement"
        class="text-center p-4"
      >
        <b-spinner />
        <p class="mt-2">
          {{ $t("common.loading") }}
        </p>
      </div>
      <DoctorAccountStatement
        v-else-if="accountStatementData.length > 0"
        :data="accountStatementData"
        :doctor-name="doctorName"
        :type="accountStatementType"
        :is-paid="accountStatementIsPaid"
        :total-amount="accountStatementTotalAmount"
        :total-discount="accountStatementTotalDiscount"
        :from-date="accountStatementFromDate"
        :to-date="accountStatementToDate"
      />
      <div
        v-else
        class="text-center p-4"
      >
        <p class="text-muted mb-0">
          {{ $t("common.no-data-available") || $t("common.no-matching-results") }}
        </p>
      </div>
    </b-modal>
    <!-- Payment Receipt Modal -->
    <b-modal
      id="modal-payment-receipt"
      :title="$t('surgery.payment-receipt')"
      size="xl"
      hide-footer
      @hide="closePaymentReceiptModal"
    >
      <DoctorPaymentReceipt
        v-if="paymentReceiptData.length > 0"
        :data="paymentReceiptData"
        :doctor-name="doctorName"
        :type="paymentReceiptType"
        :is-all-payment="paymentReceiptIsAll"
        :is-doctor-assistant="paymentReceiptIsDoctorAssistant"
        :total-amount="paymentReceiptTotalAmount"
        :total-discount="paymentReceiptTotalDiscount"
        :from-date="paymentReceiptFromDate"
        :to-date="paymentReceiptToDate"
      />
    </b-modal>
    <!-- Payment History Detail Modal -->
    <b-modal
      id="modal-payment-history-detail"
      :title="$t('accounting.payment-details') || 'تفاصيل الدفعات'"
      size="xl"
      hide-footer
      @hide="closePaymentHistoryDetailModal"
    >
      <div v-if="loadingPaymentHistoryDetail">
        <div class="d-flex justify-content-center p-4">
          <b-spinner />
          <span class="ml-2">{{ $t("common.loading") }}</span>
        </div>
      </div>
      <div v-else-if="paymentHistoryDetailData.length > 0">
        <!-- Summary Cards -->
        <b-row class="mb-3">
          <b-col
            cols="12"
            sm="4"
            class="mb-2"
          >
            <b-card class="text-center">
              <h6 class="text-muted mb-1">
                {{ $t("common.payment-date") || "تاريخ الدفع" }}
              </h6>
              <h5 class="mb-0">
                {{ formatPaymentDate(selectedPaymentDate) }}
              </h5>
            </b-card>
          </b-col>
          <b-col
            cols="12"
            sm="4"
            class="mb-2"
          >
            <b-card class="text-center">
              <h6 class="text-muted mb-1">
                {{ $t("common.total-invoices") || "إجمالي الفواتير" }}
              </h6>
              <h5 class="mb-0">
                {{ paymentHistoryDetailData.length }}
              </h5>
            </b-card>
          </b-col>
          <b-col
            cols="12"
            sm="4"
            class="mb-2"
          >
            <b-card class="text-center">
              <h6 class="text-muted mb-1">
                {{ $t("common.total-amount") || "المبلغ الإجمالي" }}
              </h6>
              <h5 class="mb-0">
                {{ formatIQDCurrency(calculateDetailTotalAmount()) }}
              </h5>
            </b-card>
          </b-col>
        </b-row>
        <!-- Detailed Payments Table -->
        <b-table
          :items="paymentHistoryDetailData"
          :fields="paymentDetailFields"
          responsive
          small
          show-empty
          :empty-text="$t('common.no-data') || 'لا توجد بيانات'"
        >
          <template #cell(type)="data">
            <b-badge
              :variant="
                data.item.type === 'surgery'
                  ? 'primary'
                  : data.item.type === 'stay'
                    ? 'info'
                    : data.item.type === 'consultancy'
                      ? 'warning'
                      : 'success'
              "
            >
              {{ getTypeLabel(data.item.type) }}
            </b-badge>
          </template>
          <template #cell(procedures)="data">
            {{ getSurgeryName(data.item) }}
          </template>
          <template #cell(total_price)="data">
            {{ formatIQDCurrency(data.item.total_price || 0) }}
          </template>
          <template #cell(doctor_price)="data">
            {{ formatIQDCurrency(data.item.doctor_price || 0) }}
          </template>
          <template #cell(start_time)="data">
            {{ formatDateTime(data.item.start_time || data.item.payment_date) }}
          </template>
        </b-table>

        <!-- Print Button -->
        <div class="d-flex justify-content-end mt-3">
          <b-button
            variant="success"
            @click="printPaymentHistoryDetail()"
          >
            <feather-icon
              icon="PrinterIcon"
              size="16"
              class="mr-50"
            />
            {{ $t("common.print") || "طباعة" }}
          </b-button>
        </div>
      </div>
      <div
        v-else
        class="text-center p-4"
      >
        <p>{{ $t("common.no-payments") || "لا توجد دفعات" }}</p>
      </div>
    </b-modal>
    <b-card>
      <b-tabs v-model="activeTab">
        <b-tab
          :title="$t('accounting.dosnt-recive-money')"
          :active="activeTab === 0"
        >
          <h1 class="text-center mb-3">
            {{ $t("common.reports") }}
          </h1>
          <div>
            <b-row class="mb-3">
              <b-col>
                <h5 class="mb-1">
                  {{ $t("hospital.doctorTotalPrices") }}
                </h5>
                <b-badge variant="secondary">{{
                  formatIQDCurrency(unifiedTotals.totalPrice || 0)
                }}</b-badge>
              </b-col>
              <b-col>
                <h5 class="mb-1">
                  {{ $t("surgery.doctor_price") }}
                </h5>
                <b-badge variant="secondary">{{
                  formatIQDCurrency(unifiedTotals.doctorPrice || 0)
                }}</b-badge>
              </b-col>
              <b-col>
                <h4 class="mb-1">
                  {{ $t("hospital.doctorTotalAfterDiscount") }}
                </h4>
                <b-badge variant="primary">{{
                  formatIQDCurrency(unifiedTotals.netTotal || 0)
                }}</b-badge>
              </b-col>
            </b-row>

            <b-row class="d-flex justify-content-end mb-2">
              <b-col lg="2">
                <b-form-group
                  :label="$t('hospital.patient-name')"
                  label-for="Name"
                >
                  <b-form-input
                    id="Name"
                    v-model="name"
                    :placeholder="$t('hospital.patient-name')"
                  />
                </b-form-group>
              </b-col>
              <b-col lg="2">
                <b-form-group
                  :label="$t('common.from')"
                  label-for="entry_date"
                >
                  <datepicker
                    v-model="from"
                    :calendar-button="true"
                    :clear-button="true"
                    :bootstrap-styling="true"
                    class="datebtn2"
                    placeholder="YYYY-MM-DD"
                  />
                </b-form-group>
              </b-col>
              <b-col lg="2">
                <b-form-group
                  :label="$t('common.to')"
                  label-for="entry_date"
                >
                  <datepicker
                    v-model="to"
                    :calendar-button="true"
                    :clear-button="true"
                    :bootstrap-styling="true"
                    class="datebtn2"
                    placeholder="YYYY-MM-DD"
                  />
                </b-form-group>
              </b-col>
              <b-col class="d-flex align-items-center mb-2 mb-lg-0">
                <b-button
                  variant="primary"
                  class="mx-2"
                  @click="getUnifiedData()"
                >
                  {{ $t("common.search") }}
                </b-button>
                <b-button
                  v-if="selectedItems.length > 0 && activeTab === 0"
                  variant="primary"
                  class="mx-2"
                  @click="showModalPaySelected()"
                >
                  <feather-icon
                    icon="CheckSquareIcon"
                    size="16"
                    class="mr-50"
                  />
                  {{ $t("surgery.pay-selected") }} ({{ selectedItems.length }})
                </b-button>
                <b-button
                  v-if="unifiedData.length > 0"
                  variant="success"
                  class="mx-2"
                  @click="showAccountStatementModal('unified')"
                >
                  <feather-icon
                    icon="FileTextIcon"
                    size="16"
                    class="mr-50"
                  />
                  {{ $t("hospital.doctor-account-statement") }}
                </b-button>
              </b-col>
            </b-row>

            <b-table
              v-if="!loading"
              :items="unifiedData"
              responsive
              :fields="
                activeTab === 1
                  ? unifiedTableColumnsWithPaymentDate
                  : unifiedTableColumns
              "
              primary-key="id"
              show-empty
              empty-text="No matching results found"
              class="position-relative"
            >
              <template #head(selected)>
                <b-form-checkbox
                  v-if="activeTab === 0"
                  :checked="areAllItemsSelected"
                  :indeterminate="areSomeItemsSelected"
                  @change="toggleSelectAll"
                />
              </template>
              <template #cell(selected)="data">
                <b-form-checkbox
                  v-if="activeTab === 0"
                  :checked="isItemSelected(data.item)"
                  @input="handleCheckboxChange(data.item, $event)"
                />
              </template>
              <template #cell(type)="data">
                <b-badge
                  :variant="
                    data.item.type === 'surgery'
                      ? 'primary'
                      : data.item.type === 'stay'
                        ? 'info'
                        : data.item.type === 'consultancy'
                          ? 'warning'
                          : 'success'
                  "
                >
                  {{ getTypeLabel(data.item.type) }}
                </b-badge>
              </template>
              <template #cell(total_price)="data">
                <span class="text-nowrap">
                  {{ formatIQDCurrency(data.item.total_price || 0) }}
                </span>
              </template>
              <template #cell(doctor_price)="data">
                <span class="text-nowrap">
                  {{ formatIQDCurrency(data.item.doctor_price || 0) }}
                </span>
              </template>
              <template #cell(procedures)="data">
                {{ getSurgeryName(data.item) }}
              </template>
              <template #cell(payment_date)="data">
                <span class="text-nowrap">
                  {{ formatPaymentDate(data.item.payment_date) }}sss
                </span>
              </template>
              <template #cell(actions)="data">
                <div class="d-flex">
                  <b-button
                    v-if="activeTab === 0"
                    variant="primary"
                    size="sm"
                    class="mr-1"
                    @click="handlePayDoctor(data.item)"
                  >
                    {{ $t("surgery.pay-doctor") }}
                  </b-button>
                  <b-button
                    variant="warning"
                    size="sm"
                    @click="showReDistributionModal(data.item)"
                  >
                    <feather-icon
                      icon="RefreshCwIcon"
                      size="14"
                      class="mr-50"
                    />
                    {{ $t("accounting.reDistribution") }}
                  </b-button>
                </div>
              </template>
            </b-table>
            <template v-if="loading">
              <div>
                <div class="d-flex justify-content-center mb-1">
                  <b-spinner label="Loading..." />
                </div>
              </div>
            </template>
            <div class="mx-2 mb-2">
              <b-row>
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-start"
                >
                  <span
                    class="text-muted"
                  >{{ $t("common.showing") }}
                    {{ unifiedData.length > 0 ? 1 : 0 }}
                    {{ $t("common.to") }}
                    {{ unifiedData.length }}
                    {{ $t("common.of") }}
                    {{ unifiedData.length }}
                  </span>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-tab>

        <b-tab
          :title="$t('accounting.recive-money')"
          :active="activeTab === 1"
        >
          <h1 class="text-center mb-3">
            {{ $t("common.reports") }}
          </h1>
          <div>
            <b-row class="mb-3">
              <b-col>
                <h5 class="mb-1">
                  {{ $t("hospital.doctorTotalPrices") }}
                </h5>
                <b-badge variant="secondary">{{
                  formatIQDCurrency(unifiedTotals.totalPrice || 0)
                }}</b-badge>
              </b-col>
              <b-col>
                <h5 class="mb-1">
                  {{ $t("surgery.doctor_price") }}
                </h5>
                <b-badge variant="secondary">{{
                  formatIQDCurrency(unifiedTotals.doctorPrice || 0)
                }}</b-badge>
              </b-col>
              <b-col>
                <h4 class="mb-1">
                  {{ $t("hospital.doctorTotalAfterDiscount") }}
                </h4>
                <b-badge variant="primary">{{
                  formatIQDCurrency(unifiedTotals.netTotal || 0)
                }}</b-badge>
              </b-col>
            </b-row>

            <b-row class="d-flex justify-content-end mb-2">
              <b-col lg="2">
                <b-form-group
                  :label="$t('hospital.patient-name')"
                  label-for="Name"
                >
                  <b-form-input
                    id="Name"
                    v-model="name"
                    :placeholder="$t('hospital.patient-name')"
                  />
                </b-form-group>
              </b-col>
              <b-col lg="2">
                <b-form-group
                  :label="$t('common.from')"
                  label-for="entry_date"
                >
                  <datepicker
                    v-model="from"
                    :calendar-button="true"
                    :clear-button="true"
                    :bootstrap-styling="true"
                    class="datebtn2"
                    placeholder="YYYY-MM-DD"
                  />
                </b-form-group>
              </b-col>
              <b-col lg="2">
                <b-form-group
                  :label="$t('common.to')"
                  label-for="entry_date"
                >
                  <datepicker
                    v-model="to"
                    :calendar-button="true"
                    :clear-button="true"
                    :bootstrap-styling="true"
                    class="datebtn2"
                    placeholder="YYYY-MM-DD"
                  />
                </b-form-group>
              </b-col>
              <b-col
                v-if="activeTab === 1"
                lg="2"
              >
                <b-form-group
                  label="من تاريخ الدفع"
                  label-for="from_payment_date"
                >
                  <datepicker
                    v-model="fromPaymentDate"
                    :calendar-button="true"
                    :clear-button="true"
                    :bootstrap-styling="true"
                    class="datebtn2"
                    placeholder="YYYY-MM-DD"
                  />
                </b-form-group>
              </b-col>
              <b-col
                v-if="activeTab === 1"
                lg="2"
              >
                <b-form-group
                  label="إلى تاريخ الدفع"
                  label-for="to_payment_date"
                >
                  <datepicker
                    v-model="toPaymentDate"
                    :calendar-button="true"
                    :clear-button="true"
                    :bootstrap-styling="true"
                    class="datebtn2"
                    placeholder="YYYY-MM-DD"
                  />
                </b-form-group>
              </b-col>
              <b-col class="d-flex align-items-center mb-2 mb-lg-0">
                <b-button
                  variant="primary"
                  class="mx-2"
                  @click="getUnifiedData()"
                >
                  {{ $t("common.search") }}
                </b-button>
                <b-button
                  v-if="unifiedData.length > 0"
                  variant="success"
                  class="mx-2"
                  @click="showAccountStatementModal('unified')"
                >
                  <feather-icon
                    icon="FileTextIcon"
                    size="16"
                    class="mr-50"
                  />
                  {{ $t("hospital.doctor-account-statement") }}
                </b-button>
              </b-col>
            </b-row>

            <b-table
              v-if="!loading"
              :items="unifiedData"
              responsive
              :fields="unifiedTableColumnsWithPaymentDate"
              primary-key="id"
              show-empty
              empty-text="No matching results found"
              class="position-relative"
            >
              <template #cell(type)="data">
                <b-badge
                  :variant="
                    data.item.type === 'surgery'
                      ? 'primary'
                      : data.item.type === 'stay'
                        ? 'info'
                        : data.item.type === 'consultancy'
                          ? 'warning'
                          : 'success'
                  "
                >
                  {{ getTypeLabel(data.item.type) }}
                </b-badge>
              </template>
              <template #cell(total_price)="data">
                <span class="text-nowrap">
                  {{ formatIQDCurrency(data.item.total_price || 0) }}
                </span>
              </template>
              <template #cell(doctor_price)="data">
                <span class="text-nowrap">
                  {{ formatIQDCurrency(data.item.doctor_price || 0) }}
                </span>
              </template>
              <template #cell(procedures)="data">
                {{ getSurgeryName(data.item) }}
              </template>
              <template #cell(payment_date)="data">
                <span class="text-nowrap">
                  {{ formatPaymentDate(data.item.payment_date) }}
                </span>
              </template>
            </b-table>
            <template v-if="loading">
              <div>
                <div class="d-flex justify-content-center mb-1">
                  <b-spinner label="Loading..." />
                </div>
              </div>
            </template>
            <div class="mx-2 mb-2">
              <b-row>
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-start"
                >
                  <span
                    class="text-muted"
                  >{{ $t("common.showing") }}
                    {{ unifiedData.length > 0 ? 1 : 0 }}
                    {{ $t("common.to") }}
                    {{ unifiedData.length }}
                    {{ $t("common.of") }}
                    {{ unifiedData.length }}
                  </span>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-tab>

        <b-tab
          :title="$t('accounting.payment-history-report') || 'تقرير سجل الدفعات'"
          :active="activeTab === 2"
        >
          <h1 class="text-center mb-3">
            {{ $t("common.reports") }}
          </h1>
          <div>
            <!-- Date Range Filters -->
            <b-row class="mb-3">
              <b-col lg="3">
                <b-form-group
                  :label="$t('common.from-date') || 'من تاريخ'"
                  label-for="history-from-date"
                >
                  <datepicker
                    id="history-from-date"
                    v-model="historyFrom"
                    :calendar-button="true"
                    :clear-button="true"
                    :bootstrap-styling="true"
                    class="datebtn2"
                    placeholder="YYYY-MM-DD"
                  />
                </b-form-group>
              </b-col>
              <b-col lg="3">
                <b-form-group
                  :label="$t('common.to-date') || 'الى تاريخ'"
                  label-for="history-to-date"
                >
                  <datepicker
                    id="history-to-date"
                    v-model="historyTo"
                    :calendar-button="true"
                    :clear-button="true"
                    :bootstrap-styling="true"
                    class="datebtn2"
                    placeholder="YYYY-MM-DD"
                  />
                </b-form-group>
              </b-col>
              <b-col
                lg="6"
                class="d-flex align-items-end mb-2 mb-lg-0"
              >
                <b-button
                  variant="primary"
                  class="mx-2"
                  :disabled="loadingPaymentHistory"
                  @click="fetchPaymentHistory()"
                >
                  <b-spinner
                    v-if="loadingPaymentHistory"
                    small
                    class="mr-50"
                  />
                  {{ $t("common.search") }}
                </b-button>
                <b-button
                  variant="outline-secondary"
                  :disabled="loadingPaymentHistory"
                  @click="resetPaymentHistoryFilters()"
                >
                  {{ $t("common.reset") || "إعادة تعيين" }}
                </b-button>
              </b-col>
            </b-row>

            <!-- Summary Cards -->
            <b-row
              v-if="paymentHistorySummary"
              class="mb-3"
            >
              <b-col
                cols="12"
                sm="6"
                lg="3"
                class="mb-2"
              >
                <b-card class="text-center">
                  <h6 class="text-muted mb-1">
                    اسم الطبيب
                  </h6>
                  <h5 class="mb-0">
                    {{ paymentHistorySummary.doctor_name || "-" }}
                  </h5>
                </b-card>
              </b-col>
              <b-col
                cols="12"
                sm="6"
                lg="3"
                class="mb-2"
              >
                <b-card class="text-center">
                  <h6 class="text-muted mb-1">
                    {{ $t("common.total-payments") || "إجمالي الدفعات" }}
                  </h6>
                  <h5 class="mb-0">
                    {{ paymentHistorySummary.total_payments || 0 }}
                  </h5>
                </b-card>
              </b-col>
              <b-col
                cols="12"
                sm="6"
                lg="3"
                class="mb-2"
              >
                <b-card class="text-center">
                  <h6 class="text-muted mb-1">
                    {{ $t("common.grand-total") || "المجموع الكلي" }}
                  </h6>
                  <h5 class="mb-0">
                    {{ formatIQDCurrency(paymentHistorySummary.grand_total || 0) }}
                  </h5>
                </b-card>
              </b-col>
              <b-col
                cols="12"
                sm="6"
                lg="3"
                class="mb-2"
              >
                <b-card class="text-center">
                  <h6 class="text-muted mb-1">
                    {{ $t("common.days-with-payments") || "أيام مع دفعات" }}
                  </h6>
                  <h5 class="mb-0">
                    {{ countActiveDays() }}
                  </h5>
                </b-card>
              </b-col>
            </b-row>

            <!-- Daily Summary Table -->
            <b-table
              v-if="!loadingPaymentHistory"
              :items="dailyPaymentSummary"
              :fields="dailySummaryFields"
              responsive
              show-empty
              :empty-text="$t('common.no-data') || 'لا توجد بيانات'"
              :tbody-tr-class="getDailyRowClass"
            >
              <template #cell(date)="data">
                {{ formatPaymentDate(data.item.date) }}
              </template>
              <template #cell(invoices_count)="data">
                <b-badge
                  :variant="data.item.invoices_count > 0 ? 'success' : 'secondary'"
                >
                  {{ data.item.invoices_count || 0 }}
                </b-badge>
              </template>
              <template #cell(paid_amount)="data">
                {{ formatIQDCurrency(data.item.paid_amount || 0) }}
              </template>
              <template #cell(actions)="data">
                <b-button
                  v-if="data.item.invoices_count > 0"
                  size="sm"
                  variant="info"
                  @click="viewPaymentHistoryDetail(data.item.date)"
                >
                  {{ $t("common.view-details") || "تفاصيل" }}
                </b-button>
                <span v-else>{{ $t("common.no-payments") || "لا توجد دفعات" }}</span>
              </template>
            </b-table>
            <template v-if="loadingPaymentHistory">
              <div class="d-flex justify-content-center mb-1">
                <b-spinner label="Loading..." />
              </div>
            </template>
          </div>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BIconSearch,
  BTab,
  BTabs,
  BBadge,
  BModal,
  BCardText,
  BFormTextarea,
  BFormCheckbox,
} from 'bootstrap-vue'
import Datepicker from 'vuejs-datepicker'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

const AutoComplete = () => import('@/components/common/AutoComplete.vue')
const DoctorNICUPatients = () => import('@/views/hospital/DoctorNICUPatients.vue')
const DoctorAccountStatement = () => import('@/components/printables/DoctorAccountStatement.vue')
const DoctorPaymentReceipt = () => import('@/components/printables/DoctorPaymentReceipt.vue')

export default {
  components: {
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BIconSearch,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    Datepicker,
    AutoComplete,
    BTab,
    BTabs,
    ToastificationContent,
    BBadge,
    BModal,
    BCardText,
    BFormTextarea,
    BFormCheckbox,
    DoctorNICUPatients,
    DoctorAccountStatement,
    DoctorPaymentReceipt,
  },

  props: {
    patientCardId: {
      type: String,
      default: null,
    },
    isHistory: {
      type: Boolean,
      default: false,
    },
    doctorName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      params: {
        form: {},
        path: '',
      },
      take: 10,
      loading: true,
      dataCount: 0,
      data: [],
      activeTab: 0,
      tableColumns: [
        {
          key: 'patient_card_surgery.patient_card.patient.name',
          label: this.$t('hospital.patient-name'),
          sortable: true,
          class: 'text-nowrap',
        },
        {
          key: 'patient_card_surgery.patient_card.patient.phone',
          label: this.$t('hospital.patient-phone'),
          sortable: true,
          class: 'text-nowrap',
        },

        {
          key: 'patient_card_surgery.patient_card.patient_case',
          label: this.$t('reception.patient-case'),
          sortable: true,
        },

        {
          key: 'patient_card_surgery.diagnosis',
          label: this.$t('reception.diagnosis'),
          sortable: true,
        },
        {
          key: 'surgery.title',
          label: this.$t('surgery.surgery'),
          sortable: true,
        },
        {
          key: 'patient_card_surgery.price',
          label: this.$t('reception.Surgery Price'),
          sortable: true,
        },
        {
          key: 'doctor_discount',
          label: this.$t('reception.Doctor Discount'),
          sortable: true,
        },
        {
          key: 'doctor_price',
          label: this.$t('surgery.doctor_price'),
          sortable: true,
        },
        {
          key: 'doctors_financial',
          label: this.$t('surgery.pay-doctor'),
        },
        {
          key: 'patient_card_surgery.surgery_date_time',
          sortable: true,
          label: this.$t('hospital.surgery-date'),
        },
        {
          key: 'actions',
          label: this.$t('common.actions'),
        },
      ],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: '',
      sortBy: 'id',
      isSortDirDesc: true,
      page: 1,
      surgery_id: '',
      payDoctorData: {},
      doctorTotals: {},
      // for doctor patient stay
      doctorPatientStayTotals: 0,
      doctorPatientStayData: [],
      doctorPatientStayDataCount: 0,
      doctorPatientStayPage: 1,
      doctorPatientStayTake: 10,
      from: '',
      to: '',
      name: '',
      fromPaymentDate: '',
      toPaymentDate: '',
      doctorPatientStayTableColumns: [
        {
          key: 'patient_card_stay.patient_card.patient.name',
          label: this.$t('hospital.patient-name'),
          sortable: true,
        },
        {
          key: 'doctor_price',
          label: this.$t('surgery.doctor_price'),
          sortable: true,
        },
        {
          key: 'patient_card_stay.price',
          label: this.$t('hospital.total-price-patient-stay'),
          sortable: true,
        },
        {
          key: 'patient_card_stay.stay_date_time',
          label: this.$t('hospital.stay_date_time'),
          sortable: true,
        },
        {
          key: 'actions',
          label: this.$t('common.actions'),
        },
        {
          key: 'created_at',
          label: this.$t('common.created_at'),
          sortable: true,
        },
      ],
      payDoctorStayData: {},

      // ---- New properties for consultancies table ----
      consultanciesData: [],
      consultanciesDataCount: 0,
      consultanciesPage: 1,
      consultanciesTake: 20,
      consultanciesTotals: 0,
      consultanciesTableColumns: [
        {
          key: 'patient_card_surgery.patient_card.patient.name',
          label: this.$t('hospital.patient-name'),
          sortable: true,
          class: 'text-nowrap',
        },
        {
          key: 'doctor_price',
          label: this.$t('surgery.Doctor-consultancy-price'),
          sortable: true,
          class: 'text-nowrap',
        },
        {
          key: 'patient_card_surgery.price',
          label: this.$t('reception.Surgery Price'),
          sortable: true,
        },
        {
          key: 'patient_card_surgery.patient_card.patient.phone',
          label: this.$t('hospital.patient-phone'),
          sortable: true,
          class: 'text-nowrap',
        },
        {
          key: 'patient_card_surgery.surgery.title',
          label: this.$t('surgery.surgery'),
          sortable: true,
          class: 'text-nowrap',
        },
        {
          key: 'patient_card_surgery.surgery_date_time',
          label: this.$t('hospital.surgery-date'),
          sortable: true,
        },
        {
          key: 'actions',
          label: this.$t('common.actions'),
        },
        {
          key: 'created_at',
          label: this.$t('common.created_at'),
          sortable: true,
        },
      ],
      payConsultanciesData: {},
      // Account Statement data
      loadingAccountStatement: false,
      accountStatementData: [],
      accountStatementType: 'surgeries',
      accountStatementIsPaid: false,
      accountStatementTotalAmount: 0,
      accountStatementTotalDiscount: 0,
      doctorName: '',
      accountStatementFromDate: '',
      accountStatementToDate: '',
      // Payment Receipt data
      paymentReceiptData: [],
      paymentReceiptType: 'surgeries',
      paymentReceiptIsAll: false,
      paymentReceiptIsDoctorAssistant: false, // This is for doctors, not assistants
      paymentReceiptTotalAmount: 0,
      paymentReceiptTotalDiscount: 0,
      paymentReceiptFromDate: '',
      paymentReceiptToDate: '',
      // ReDistribution
      redistributionReason: 'Incorrect doctor amount',
      selectedItemForRedistribution: null,
      // Unified data
      unifiedData: [],
      unifiedDataCount: 0,
      unifiedPage: 1,
      unifiedTake: 10000, // Fetch all items from API (increased limit)
      selectedItems: [],
      selectedItemKeys: new Set(),
      unifiedTotals: {
        totalPrice: 0,
        doctorPrice: 0,
        netTotal: 0,
      },
      unifiedTableColumns: [
        {
          key: 'selected',
          label: '',
          sortable: false,
        },
        {
          key: 'patient_name',
          label: this.$t('hospital.patient-name'),
          sortable: true,
        },
        {
          key: 'type',
          label: this.$t('common.type'),
          sortable: true,
        },
        {
          key: 'procedures',
          label: this.$t('surgery.surgery-or-service'),
          sortable: true,
        },
        {
          key: 'total_price',
          label: this.$t('reception.Surgery Price'),
          sortable: true,
        },
        {
          key: 'doctor_price',
          label: this.$t('surgery.doctor_price'),
          sortable: true,
        },
        {
          key: 'approved_at',
          label: this.$t('common.date'),
          sortable: true,
        },
        {
          key: 'actions',
          label: this.$t('common.actions'),
        },
      ],
      // Payment History Report
      historyFrom: null,
      historyTo: null,
      loadingPaymentHistory: false,
      paymentHistorySummary: null,
      dailyPaymentSummary: [],
      // Payment Detail Modal
      selectedPaymentDate: null,
      loadingPaymentHistoryDetail: false,
      paymentHistoryDetailData: [],
      dailySummaryFields: [
        {
          key: 'date',
          label: this.$t('common.date') || 'التاريخ',
          sortable: true,
        },
        {
          key: 'invoices_count',
          label: this.$t('common.invoices-count') || 'عدد الفواتير',
          sortable: true,
        },
        {
          key: 'paid_amount',
          label: 'المبلغ المدفوع',
          sortable: true,
        },
        {
          key: 'actions',
          label: this.$t('common.actions') || 'إجراءات',
        },
      ],
      paymentDetailFields: [
        {
          key: 'patient_name',
          label: this.$t('hospital.patient-name'),
        },
        {
          key: 'type',
          label: this.$t('common.type'),
        },
        {
          key: 'procedures',
          label: this.$t('surgery.surgery-or-service'),
        },
        {
          key: 'total_price',
          label: this.$t('common.price'),
        },
        {
          key: 'doctor_price',
          label: this.$t('surgery.doctor_price'),
        },
        {
          key: 'start_time',
          label: this.$t('common.date'),
        },
      ],
    }
  },
  computed: {
    unifiedTableColumnsWithPaymentDate() {
      const columns = [...this.unifiedTableColumns]
      // Add payment_date column only for paid tab (activeTab === 1)
      if (this.activeTab === 1) {
        const dateColIndex = columns.findIndex(
          col => col.key === 'approved_at',
        )
        const insertIndex = dateColIndex !== -1 ? dateColIndex + 1 : columns.length - 1
        columns.splice(insertIndex, 0, {
          key: 'payment_date',
          label: 'تاريخ دفع الطبيب',
          sortable: true,
        })
      }
      return columns
    },
    selectedItemsTotalPrice() {
      return this.selectedItems.reduce(
        (sum, item) => sum + (parseFloat(item.total_price) || 0),
        0,
      )
    },
    selectedItemsTotalDoctorPrice() {
      return this.selectedItems.reduce(
        (sum, item) => sum + (parseFloat(item.doctor_price) || 0),
        0,
      )
    },
    selectedItemsNetTotal() {
      return this.selectedItemsTotalDoctorPrice
    },
    areAllItemsSelected() {
      if (this.unifiedData.length === 0) return false
      return (
        this.unifiedData.length > 0
        && this.unifiedData.every(item => this.isItemSelected(item))
      )
    },
    areSomeItemsSelected() {
      return (
        this.selectedItems.length > 0 && !this.areAllItemsSelected
      )
    },
  },
  watch: {
    activeTab(newTab) {
      if (newTab === 2) {
        // Payment History Report tab: fetch on first mount (call works without date filters)
        this.fetchPaymentHistory()
      } else {
        // Other tabs
        // Reset to page 1 when switching tabs
        this.unifiedPage = 1
        // Clear selection when switching tabs
        this.selectedItems = []
        this.selectedItemKeys = new Set()
        // Clear payment history data when leaving tab 2
        if (newTab !== 2) {
          this.paymentHistorySummary = null
          this.dailyPaymentSummary = []
          this.selectedPaymentDate = null
          this.paymentHistoryDetailData = []
        }
        this.getUnifiedData()
      }
    },
    doctorName: {
      handler(newName) {
        // Sync prop value to data property
        if (newName) {
          this.doctorName = newName
        }
      },
      immediate: true,
    },
    $route(to) {
      // Get doctor name from query parameter if available when route changes
      if (to.query.doctorName && !this.doctorName) {
        this.doctorName = to.query.doctorName
      }
    },
  },
  mounted() {
    // Set doctor name from prop or query parameter
    if (!this.doctorName) {
      if (this.$route.query.doctorName) {
        this.doctorName = this.$route.query.doctorName
      }
    }
    this.getUnifiedData()
    this.fetchStatistics() // Fetch statistics for parent
  },
  methods: {
    getNestedProperty(obj, path, defaultValue = 'N/A') {
      try {
        const result = path
          .split('.')
          .reduce(
            (acc, part) => (acc && acc[part] !== undefined ? acc[part] : undefined),
            obj,
          )

        // Return 0 for null, undefined, or NaN
        if (result === null || result === undefined || Number.isNaN(result)) {
          return 0
        }

        return result
      } catch {
        return 0
      }
    },

    // for doctor patient stay
    async getDoctorPatientStay() {
      this.loading = true
      let url = `/patient-stay/doctor/${this.$route.params.id}?page=${this.doctorPatientStayPage}&take=${this.doctorPatientStayTake}&include=patientCardStay&sort=-id&payment_status=${this.activeTab}`
      if (this.from) {
        url += `&from=${this.formatDate(this.from)}`
      }
      if (this.to) {
        url += `&to=${this.formatDate(this.to)}`
      }

      await this.getList(url)

      this.doctorPatientStayTotals = this.all_data.total_price_for_unpaid_stays
      this.doctorPatientStayDataCount = this.all_data.data.total
      this.doctorPatientStayData = this.all_data.data.data

      this.loading = false
    },

    // for doctor surgeries
    formatIQDCurrency(value) {
      // Create a new Intl.NumberFormat object for IQD currency
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'IQD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })

      // Format the value and return it
      return formatter.format(value)
    },
    showModal(status) {
      this.$bvModal.show('modal-pay-doctor')
      this.payDoctorData = status
    },
    getItemKey(item) {
      // Create a unique key for each item using id and type
      if (!item) return ''
      // Use a combination that ensures uniqueness
      const id = item.id
        || item.invoice_id
        || item.patient_card_surgery_id
        || item.patient_card_stay_id
        || ''
      const type = item.type || ''
      return `${type}_${id}`
    },
    isItemSelected(item) {
      if (!item) return false
      const itemKey = this.getItemKey(item)
      return this.selectedItemKeys.has(itemKey)
    },
    handleCheckboxChange(item, checked) {
      if (!item) return

      // Bootstrap Vue checkbox @input passes the checked value directly as boolean
      // Handle both boolean and event object cases
      let isChecked = false
      if (typeof checked === 'boolean') {
        isChecked = checked
      } else if (checked && checked.target) {
        isChecked = checked.target.checked
      } else {
        isChecked = !!checked
      }

      const itemKey = this.getItemKey(item)

      if (isChecked) {
        // Add to selected items
        if (!this.selectedItemKeys.has(itemKey)) {
          this.selectedItemKeys.add(itemKey)
          this.selectedItems.push({ ...item })
        }
      } else {
        // Remove from selected items
        if (this.selectedItemKeys.has(itemKey)) {
          this.selectedItemKeys.delete(itemKey)
          const index = this.selectedItems.findIndex(selected => {
            if (!selected) return false
            return this.getItemKey(selected) === itemKey
          })
          if (index !== -1) {
            this.selectedItems.splice(index, 1)
          }
        }
      }
    },
    toggleItemSelection(item) {
      if (!item) return

      const itemKey = this.getItemKey(item)
      const isCurrentlySelected = this.selectedItemKeys.has(itemKey)

      if (isCurrentlySelected) {
        // Remove from selected items
        this.selectedItemKeys.delete(itemKey)
        const index = this.selectedItems.findIndex(selected => {
          if (!selected) return false
          return this.getItemKey(selected) === itemKey
        })
        if (index !== -1) {
          this.selectedItems.splice(index, 1)
        }
      } else {
        // Add to selected items
        this.selectedItemKeys.add(itemKey)
        this.selectedItems.push({ ...item })
      }
    },
    toggleSelectAll(event) {
      const isChecked = event
      if (isChecked) {
        // Select all items
        this.unifiedData.forEach(item => {
          if (item) {
            const itemKey = this.getItemKey(item)
            if (!this.selectedItemKeys.has(itemKey)) {
              this.selectedItemKeys.add(itemKey)
              this.selectedItems.push({ ...item })
            }
          }
        })
      } else {
        // Deselect all items
        this.selectedItems = []
        this.selectedItemKeys = new Set()
      }
    },
    showModalPaySelected() {
      this.$bvModal.show('modal-pay-selected-items')
    },
    async paySelectedItems() {
      if (this.selectedItems.length === 0) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'No items selected',
            icon: 'AlertCircleIcon',
            variant: 'warning',
            text: 'Please select at least one item to pay',
          },
        })
        return
      }

      // Ensure doctor name is set before showing receipt
      if (!this.doctorName) {
        if (this.$route.query.doctorName) {
          this.doctorName = this.$route.query.doctorName
        }
      }

      try {
        console.log('paySelectedItems called with:', this.selectedItems)
        console.log(
          'First selected item structure:',
          this.selectedItems[0]
            ? Object.keys(this.selectedItems[0])
            : 'No items',
        )

        // Collect all invoice IDs from different types
        const invoiceIds = []

        // Process each selected item and try multiple possible field names
        this.selectedItems.forEach(item => {
          if (!item) return

          // Try multiple possible field names for invoice ID
          // For unified data, the structure might be different
          let possibleInvoiceId = item.invoice_id
            || item.invoice_out_clinic_id
            || item.patient_card_surgery_id
            || item.patient_card_stay_id
            || item.patient_card_consultancy_id
            || (item.patient_card_surgery
              && item.patient_card_surgery.invoice_id)
            || (item.patient_card_stay && item.patient_card_stay.invoice_id)

          // If no invoice_id found, try using the item's id field
          // For unified data, the id might be the invoice ID itself
          if (!possibleInvoiceId && item.id) {
            // Check if id looks like a valid ID (number or numeric string)
            const idValue = item.id
            if (idValue !== null && idValue !== undefined && idValue !== '') {
              possibleInvoiceId = idValue
            }
          }

          if (possibleInvoiceId) {
            invoiceIds.push(possibleInvoiceId)
            console.log(
              `Found invoice ID for ${item.type}:`,
              possibleInvoiceId,
              'from item:',
              {
                type: item.type,
                id: item.id,
                invoice_id: item.invoice_id,
              },
            )
          } else {
            console.warn('No invoice ID found for item:', {
              type: item.type,
              id: item.id,
              allKeys: Object.keys(item),
              item,
            })
          }
        })

        console.log('Collected invoice IDs:', invoiceIds)

        if (invoiceIds.length === 0) {
          // Log detailed information about selected items for debugging
          const itemDetails = this.selectedItems.map((item, index) => ({
            index,
            type: item.type,
            keys: Object.keys(item),
            values: Object.entries(item).slice(0, 10), // First 10 entries
          }))
          console.error('No invoice IDs found. Item details:', itemDetails)

          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'No valid invoices',
              icon: 'AlertCircleIcon',
              variant: 'warning',
              text: `No valid invoice IDs found in ${this.selectedItems.length} selected items. Check console for details.`,
            },
          })
          return
        }

        // Use the bulk payment endpoint with new format
        const payments = invoiceIds.map(invoiceId => ({
          doctor_id: this.$route.params.id,
          invoice_id: invoiceId,
        }))

        this.params.form = { payments }
        this.params.path = 'invoices/bulk-pay-doctor'

        const response = await this.$store.dispatch('put', this.params)

        console.log('Bulk payment response:', response)

        // Show payment receipt for selected items
        this.showPaymentReceiptModal('unified', this.selectedItems, false)

        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Payment Successful',
            icon: 'CheckCircleIcon',
            variant: 'success',
            text:
              response.data?.message
              || `Successfully paid ${invoiceIds.length} invoices`,
          },
        })

        // Clear selection and refresh
        this.selectedItems = []
        this.selectedItemKeys = new Set()
        await this.getUnifiedData()
        await this.fetchStatistics()
      } catch (error) {
        console.error('Bulk payment error:', error)
        await this.getUnifiedData()
        await this.fetchStatistics()
        // if (error.response) {
        //   if (error.response.status === 400) {
        //     Object.keys(error.response.data).forEach((item) => {
        //       this.$toast({
        //         component: ToastificationContent,
        //         position: "top-right",
        //         props: {
        //           title: "Validation Error",
        //           variant: "danger",
        //           text: error.response.data[item][0],
        //         },
        //       });
        //     });
        //   } else {
        //     this.$toast({
        //       component: ToastificationContent,
        //       position: "top-right",
        //       props: {
        //         title: "Payment Failed",
        //         icon: "XCircleIcon",
        //         variant: "danger",
        //         text:
        //           error.response.data?.message ||
        //           "Failed to process payment. Please try again.",
        //       },
        //     });
        //   }
        // } else {
        //   this.$toast({
        //     component: ToastificationContent,
        //     position: "top-right",
        //     props: {
        //       title: "Error",
        //       icon: "XCircleIcon",
        //       variant: "danger",
        //       text: "Network error or request failed",
        //     },
        //   });
        // }
      }
    },
    getDoctorPrice(doctorsPrices) {
      if (!doctorsPrices || !doctorsPrices.items) {
        return 'Price not available'
      }

      const doctorItem = doctorsPrices.items.find(
        item => item && item.doctor_id == this.$route.params.id,
      )

      return doctorItem?.price || 'Price not available'
    },
    getDoctorDiscount(doctorsDiscounts) {
      if (!doctorsDiscounts || !doctorsDiscounts.items) {
        return 'Price not available'
      }

      const doctorItem = doctorsDiscounts.items.find(
        item => item && item.doctor_id == this.$route.params.id,
      )

      return doctorItem?.doctor_discount || '0'
    },
    handlePageChange(page) {
      // This method is no longer needed for API pagination
      // Local pagination is handled by v-model on b-pagination
      // Keeping for backward compatibility but not used
    },
    async getUnifiedData() {
      this.loading = true

      // Clear selected items when refreshing data
      this.selectedItems = []
      this.selectedItemKeys = new Set()

      // Use unified-data endpoint
      let url = `/doctor/${this.$route.params.id}/unified-data?page=${this.unifiedPage}&take=${this.unifiedTake}&types=all&sort=-id`

      if (this.from) {
        url += `&approved_at_from=${this.formatDate(this.from)}`
      }
      if (this.to) {
        url += `&approved_at_to=${this.formatDate(this.to)}`
      }
      if (this.name) {
        url += `&filter[patient_name]=${this.name}`
      }

      // Add payment_status filter based on activeTab
      // activeTab 0 = unpaid (payment_status 0)
      // activeTab 1 = paid (payment_status 1)
      url += `&payment_status=${this.activeTab}`

      // Add payment_date filters only for paid tab (activeTab === 1), with time for full day
      if (this.activeTab === 1) {
        if (this.fromPaymentDate) {
          url += `&payment_date_from=${encodeURIComponent(this.formatDateWithTimeStart(this.fromPaymentDate))}`
        }
        if (this.toPaymentDate) {
          url += `&payment_date_to=${encodeURIComponent(this.formatDateWithTimeEnd(this.toPaymentDate))}`
        }
      }

      await this.getList(url)

      // Handle the response structure from unified-data endpoint
      // The response has: { data: [...items], current_page, per_page, total, last_page }
      this.unifiedDataCount = this.all_data.total || 0
      this.unifiedData = this.all_data.data || []

      // Clear selection when refreshing data
      this.selectedItems = []
      this.selectedItemKeys = new Set()

      // Calculate totals from ALL fetched data (not just current page)
      this.unifiedTotals.totalPrice = this.unifiedData.reduce(
        (sum, item) => sum + parseFloat(item.total_price || 0),
        0,
      )
      this.unifiedTotals.doctorPrice = this.unifiedData.reduce(
        (sum, item) => sum + parseFloat(item.doctor_price || 0),
        0,
      )
      this.unifiedTotals.netTotal = this.unifiedTotals.doctorPrice

      this.loading = false
    },
    getTypeLabel(type) {
      const labels = {
        surgery: this.$t('hospital.doctor-surgeries'),
        stay: this.$t('hospital.doctor-patient-stay'),
        consultancy: this.$t('surgery.doctor-consultancies'),
        nicu: this.$t('incubator.nicu-patients'),
      }
      return labels[type] || type
    },
    getSurgeryName(item) {
      // Try multiple sources for surgery/service name in priority order
      // 1. Check invoice.surgery_name
      if (item.invoice && item.invoice.surgery_name) {
        return item.invoice.surgery_name
      }
      // 2. Check invoice.service_name
      if (item.invoice && item.invoice.service_name) {
        return item.invoice.service_name
      }
      // 3. Check invoice.name
      if (item.invoice && item.invoice.name) {
        return item.invoice.name
      }

      // 4. Check invoice_out_clinic.surgery_name
      if (item.invoice_out_clinic && item.invoice_out_clinic.surgery_name) {
        return item.invoice_out_clinic.surgery_name
      }
      // 5. Check invoice_out_clinic.service_name
      if (item.invoice_out_clinic && item.invoice_out_clinic.service_name) {
        return item.invoice_out_clinic.service_name
      }
      // 6. Check invoice_out_clinic.name
      if (item.invoice_out_clinic && item.invoice_out_clinic.name) {
        return item.invoice_out_clinic.name
      }
      // 7. Check invoice_out_clinic.service.title
      if (
        item.invoice_out_clinic
        && item.invoice_out_clinic.service
        && item.invoice_out_clinic.service.title
      ) {
        return item.invoice_out_clinic.service.title
      }

      // 8. Check invoice_patient_surgery.surgery_name
      if (
        item.invoice_patient_surgery
        && item.invoice_patient_surgery.surgery_name
      ) {
        return item.invoice_patient_surgery.surgery_name
      }
      // 9. Check invoice_patient_surgery.service_name
      if (
        item.invoice_patient_surgery
        && item.invoice_patient_surgery.service_name
      ) {
        return item.invoice_patient_surgery.service_name
      }
      // 10. Check invoice_patient_surgery.name
      if (item.invoice_patient_surgery && item.invoice_patient_surgery.name) {
        return item.invoice_patient_surgery.name
      }

      // 11. Check root level service_name
      if (item.service_name) {
        return item.service_name
      }
      // 12. Check procedures field
      if (item.procedures) {
        return item.procedures
      }

      // 13. Check nested invoice.service object
      if (item.invoice && item.invoice.service && item.invoice.service.title) {
        return item.invoice.service.title
      }
      // 14. Check nested invoice.surgery object
      if (item.invoice && item.invoice.surgery && item.invoice.surgery.title) {
        return item.invoice.surgery.title
      }

      // 15. Fallback based on unified record type when no explicit name exists
      switch (item.type) {
        case 'stay':
          return 'إقامة المريض'
        case 'outclinic':
          return 'خدمة عيادة خارجية'
        case 'surgery':
          return 'عملية جراحية'
        case 'consultancy':
          return 'استشارة طبية'
        case 'nicu':
          return 'خدمات الخدج / العناية المركزة'
        default:
          return '-'
      }
    },
    handlePayDoctor(item) {
      // Handle payment based on type
      if (item.type === 'surgery') {
        this.payDoctorData = item
        this.$bvModal.show('modal-pay-doctor')
      } else if (item.type === 'outclinic') {
        this.payDoctorData = item
        this.$bvModal.show('modal-pay-doctor')
      } else if (item.type === 'stay') {
        this.payDoctorStayData = item
        this.$bvModal.show('modal-pay-doctor-stay')
      } else if (item.type === 'consultancy') {
        this.payConsultanciesData = item
        this.$bvModal.show('modal-pay-doctor-consultancies')
      }
    },
    async getDoctorsSurgeries() {
      // Keep for backward compatibility, redirect to unified
      this.getUnifiedData()
    },

    async fetchStatistics() {
      try {
        // Fetch unpaid surgeries statistics
        const unpaidUrl = `/patient-surgery/doctor/${this.$route.params.id}?take=1&payment_status=0&sort=-created_at`
        await this.getList(unpaidUrl)
        const unpaidTotal = this.all_data.data.total || 0
        const unpaidAmount = (this.all_data.total_price_for_unpaid_surgeries || 0)
          - (this.all_data.total_discount_for_unpaid_surgeries || 0)

        // Fetch paid surgeries statistics
        const paidUrl = `/patient-surgery/doctor/${this.$route.params.id}?take=1&payment_status=1&sort=-created_at`
        await this.getList(paidUrl)
        const paidTotal = this.all_data.data.total || 0

        // Emit complete statistics
        this.$emit('surgery-statistics-updated', {
          received_money_count: paidTotal,
          not_received_money_count: unpaidTotal,
          not_received_money_total: unpaidAmount,
          total_surgeries: paidTotal + unpaidTotal,
        })
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching statistics:', error)
      }
    },
    formatDate(date) {
      const newDate = new Date(date)
      const year = newDate.getFullYear()
      const month = String(newDate.getMonth() + 1).padStart(2, '0')
      const day = String(newDate.getDate()).padStart(2, '0')

      return `${year}-${month}-${day}`
    },
    /** Date with time for payment_date_from: start of day 00:01 */
    formatDateWithTimeStart(date) {
      if (!date) return ''
      const d = this.formatDate(date)
      return `${d} 00:00`
    },
    /** Date with time for payment_date_to: end of day 23:59 */
    formatDateWithTimeEnd(date) {
      if (!date) return ''
      const d = this.formatDate(date)
      return `${d} 23:59`
    },
    formatPaymentDate(date) {
      if (!date) return '-'
      return this.formatDate(date)
    },
    payDoctorPrice() {
      console.log(
        'payDoctorPrice called, full data:',
        JSON.stringify(this.payDoctorData, null, 2),
      )
      console.log('Available keys:', Object.keys(this.payDoctorData))

      // Ensure doctor name is set before showing receipt
      if (!this.doctorName) {
        if (this.$route.query.doctorName) {
          this.doctorName = this.$route.query.doctorName
        }
      }

      // Try different possible invoice ID fields
      const invoiceId = this.payDoctorData.invoice_id
        || this.payDoctorData.id
        || this.payDoctorData.invoice_out_clinic_id
        || this.payDoctorData.patient_card_surgery_id

      console.log('Invoice ID:', invoiceId)
      console.log('Data type:', this.payDoctorData.type)

      if (!invoiceId) {
        const availableFields = Object.keys(this.payDoctorData).join(', ')
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Validation Error',
            variant: 'danger',
            text: `Invoice ID not found. Available fields: ${availableFields}`,
          },
        })
        return
      }

      this.params.form = {
        doctor_id: this.$route.params.id,
        invoice_id: invoiceId,
      }
      this.params.path = 'pay-doctor'

      this.$store
        .dispatch('put', this.params)
        .then(response => {
          console.log('Pay doctor response:', response)

          // Show payment receipt for single item - use unified type
          this.showPaymentReceiptModal('unified', [this.payDoctorData], false)

          this.getDoctorsSurgeries()
          this.fetchStatistics() // Update statistics

          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Success',
              variant: 'success',
              text:
                response.data?.message
                || 'Doctor payments marked as paid successfully',
            },
          })
        })
        .catch(error => {
          console.error('Payment error:', error)
          if (error.response) {
            if (error.response.status === 400) {
              Object.keys(error.response.data).forEach(item => {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'Validation Error',
                    variant: 'danger',
                    text: error.response.data[item][0],
                  },
                })
              })
            } else {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'Error',
                  variant: 'danger',
                  text: error.response.data?.message || 'Payment failed',
                },
              })
            }
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Error',
                variant: 'danger',
                text: 'Network error or request failed',
              },
            })
          }
        })
    },
    showModalStay(item) {
      this.$bvModal.show('modal-pay-doctor-stay')
      this.payDoctorStayData = item
    },
    async payDoctorForStay() {
      const data = {
        doctor_id: this.$route.params.id,
        patient_card_stay_id: this.payDoctorStayData.patient_card_stay_id,
      }

      try {
        this.params.form = data
        this.params.path = '/payDoctorForPatientStays'
        await this.$store.dispatch('put', this.params)

        // Show payment receipt
        this.showPaymentReceiptModal(
          'patient-stay',
          this.payDoctorStayData,
          false,
        )

        this.getDoctorPatientStay()
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Pay Doctor',
            variant: 'success',
            text: 'Doctor has been paid successfully for the patient stay',
          },
        })
      } catch (error) {
        if (error.response?.status === 400) {
          for (const item in error.response.data) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Validation Error',
                variant: 'danger',
                text: error.response.data[item][0],
              },
            })
          }
        }
      }
    },

    // ---- New method for getting surgery consultancies ----
    async getSurgeryConsultancies() {
      this.loading = true
      let url = `/patient-surgery-consultancies/doctor/${this.$route.params.id}?page=${this.consultanciesPage}&take=${this.consultanciesTake}&include=patientCardSurgery&payment_status=${this.activeTab}&sort=-created_at`
      if (this.to) {
        url += `&to=${this.formatDate(this.to)}`
      }
      if (this.from) {
        url += `&from=${this.formatDate(this.from)}`
      }
      await this.getList(url)
      this.consultanciesDataCount = this.all_data.data.total
      this.consultanciesData = this.all_data.data.data
      this.consultanciesTotals = this.all_data.total_price_for_unpaid_consultancies || 0
      this.loading = false
    },
    // ---- End new method ----

    // Call this from the consultancies table action button to show the modal
    showModalConsultancies(item) {
      this.$bvModal.show('modal-pay-doctor-consultancies')
      this.payConsultanciesData = item
    },

    // New method using API payDoctorForPatientConsultancies
    payConsultancies() {
      const data = {
        doctor_id: this.$route.params.id,
        patient_card_surgery_id:
          this.payConsultanciesData.patient_card_surgery_id,
      }

      this.params.form = data
      this.params.path = '/payDoctorForPatientConsultancies'

      this.$store
        .dispatch('put', this.params)
        .then(response => {
          // Show payment receipt
          this.showPaymentReceiptModal(
            'consultancies',
            this.payConsultanciesData,
            false,
          )

          // Refresh the consultancies list after a successful payment
          this.getSurgeryConsultancies()
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'pay doctor',
              variant: 'success',
              text: 'Doctor has been paid successfully for this consultancy',
            },
          })
        })
        .catch(error => {
          if (error.response && error.response.status === 400) {
            for (const key in error.response.data) {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'validation error',
                  variant: 'danger',
                  text: error.response.data[key][0],
                },
              })
            }
          }
        })
    },

    // Account Statement Methods
    async showAccountStatementModal(type) {
      // Always use "unified" type for account statement to use unified-data endpoint
      this.accountStatementType = 'unified'
      this.accountStatementData = []
      this.loadingAccountStatement = true
      // Set payment status based on active tab (0 = unpaid, 1 = paid)
      this.accountStatementIsPaid = this.activeTab === 1

      // Ensure doctor name is set from prop, query, or API
      if (!this.doctorName) {
        if (this.$route.query.doctorName) {
          this.doctorName = this.$route.query.doctorName
        } else {
          await this.getPatient(`doctor/${this.$route.params.id}`)
          this.doctorName = this.all_data.name || ''
        }
      }

      this.$bvModal.show('modal-account-statement')

      try {
        // Fetch all data without pagination using unified endpoint
        await this.fetchAllDataForStatement(type)
      } finally {
        this.loadingAccountStatement = false
      }
    },

    async fetchAllDataForStatement(type) {
      // Use unified-data endpoint for account statement
      let url = `/doctor/${this.$route.params.id}/unified-data?page=1&take=1000&types=all&payment_status=${this.activeTab}&sort=-id`

      if (this.from) {
        url += `&approved_at_from=${this.formatDate(this.from)}`
      }
      if (this.to) {
        url += `&approved_at_to=${this.formatDate(this.to)}`
      }
      if (this.name) {
        url += `&filter[patient_name]=${this.name}`
      }
      // Add payment_date filters only for paid tab (activeTab === 1), with time for full day
      if (this.activeTab === 1) {
        if (this.fromPaymentDate) {
          url += `&payment_date_from=${encodeURIComponent(this.formatDateWithTimeStart(this.fromPaymentDate))}`
        }
        if (this.toPaymentDate) {
          url += `&payment_date_to=${encodeURIComponent(this.formatDateWithTimeEnd(this.toPaymentDate))}`
        }
      }

      await this.getList(url)

      // The unified endpoint returns data directly in all_data.data
      this.accountStatementData = this.all_data.data || []

      // Calculate totals from unified data structure
      // total_price is the amount before discount
      // doctor_price is the net amount after discount
      this.accountStatementTotalAmount = this.accountStatementData.reduce(
        (sum, item) => sum + parseFloat(item.total_price || 0),
        0,
      )

      // Calculate total discount (total_price - doctor_price)
      this.accountStatementTotalDiscount = this.accountStatementData.reduce(
        (sum, item) => {
          const totalPrice = parseFloat(item.total_price || 0)
          const doctorPrice = parseFloat(item.doctor_price || 0)
          return sum + (totalPrice - doctorPrice)
        },
        0,
      )

      // Save current date range (for printing header)
      this.accountStatementFromDate = this.from
        ? this.formatDate(this.from)
        : ''
      this.accountStatementToDate = this.to ? this.formatDate(this.to) : ''
    },

    closeAccountStatementModal() {
      this.accountStatementData = []
      this.loadingAccountStatement = false
    },

    // Payment Receipt Methods
    showPaymentReceiptModal(type, data, isAll = false) {
      // Ensure doctor name is set before showing receipt
      if (!this.doctorName) {
        if (this.$route.query.doctorName) {
          this.doctorName = this.$route.query.doctorName
        }
      }

      this.paymentReceiptType = type
      this.paymentReceiptIsAll = isAll
      this.paymentReceiptData = Array.isArray(data) ? data : [data]

      // Calculate totals
      this.paymentReceiptTotalAmount = this.paymentReceiptData.reduce(
        (sum, item) => {
          let amount = 0
          if (type === 'unified') {
            // For unified data, use total_price field
            amount = parseFloat(item.total_price || 0)
          } else if (type === 'nicu') {
            // Use total_doctor_amount from backend if available
            if (
              item.total_doctor_amount !== undefined
              && item.total_doctor_amount !== null
            ) {
              amount = parseFloat(item.total_doctor_amount || 0)
            } else if (
              item.invoice_patient_incubators
              && Array.isArray(item.invoice_patient_incubators)
              && item.invoice_patient_incubators.length > 0
            ) {
              // Fallback: calculate from invoice_patient_incubators array
              amount = item.invoice_patient_incubators.reduce(
                (invoiceSum, invoice) => invoiceSum + parseFloat(invoice.doctor_amount || 0),
                0,
              )
            } else {
              // Final fallback to amount
              amount = parseFloat(item.amount || 0)
            }
          } else if (type === 'patient-stay') {
            amount = parseFloat(
              (item.patient_card_stay && item.patient_card_stay.price)
                  || item.amount
                  || 0,
            ) || 0
          } else if (type === 'consultancies') {
            amount = parseFloat(item.doctor_price || 0)
          } else {
            amount = parseFloat(
              item.doctor_price
                  || (item.patient_card_surgery
                    && item.patient_card_surgery.price)
                  || item.amount
                  || 0,
            ) || 0
          }
          return sum + amount
        },
        0,
      )

      // Calculate total discount
      if (type === 'unified') {
        // For unified data, discount is total_price - doctor_price
        this.paymentReceiptTotalDiscount = this.paymentReceiptData.reduce(
          (sum, item) => {
            const totalPrice = parseFloat(item.total_price || 0)
            const doctorPrice = parseFloat(item.doctor_price || 0)
            return sum + (totalPrice - doctorPrice)
          },
          0,
        )
      } else {
        this.paymentReceiptTotalDiscount = this.paymentReceiptData.reduce(
          (sum, item) => sum + parseFloat(item.doctor_discount || 0),
          0,
        )
      }

      // Save current date range (for printing header)
      this.paymentReceiptFromDate = this.from ? this.formatDate(this.from) : ''
      this.paymentReceiptToDate = this.to ? this.formatDate(this.to) : ''

      this.$bvModal.show('modal-payment-receipt')
    },

    closePaymentReceiptModal() {
      this.paymentReceiptData = []
    },

    // Handle NICU payment receipt event
    handleNICUPaymentReceipt({ type, data, isAll }) {
      this.showPaymentReceiptModal(type, data, isAll)
    },

    // ReDistribution methods
    showReDistributionModal(item) {
      this.selectedItemForRedistribution = item
      this.redistributionReason = 'Incorrect doctor amount'
      this.$bvModal.show('modal-redistribution')
    },

    cancelReDistribution() {
      this.selectedItemForRedistribution = null
      this.redistributionReason = 'Incorrect doctor amount'
    },

    async confirmReDistribution() {
      if (!this.selectedItemForRedistribution) {
        return
      }

      const item = this.selectedItemForRedistribution
      let apiPath = ''
      let entityId = ''

      // Determine which endpoint to use based on the item structure
      // For NICU Patients - use incubator endpoint
      if (item.patient_card_incubator_id) {
        entityId = item.patient_card_incubator_id
        apiPath = `/incubator/${entityId}/revert-distribution`
      }
      // For Surgeries - use surgery endpoint
      else if (item.patient_card_surgery_id) {
        entityId = item.patient_card_surgery_id
        apiPath = `/surgery/${entityId}/revert-distribution`
      }
      // For Patient Stay - use stay endpoint
      else if (item.patient_card_stay_id) {
        entityId = item.patient_card_stay_id
        apiPath = `/stay/${entityId}/revert-distribution`
      }
      // Fallback to generic invoice endpoint
      else if (item.invoice_id || item.id) {
        entityId = item.invoice_id || item.id
        apiPath = `/invoices/${entityId}/revert-distribution`
      }

      if (!entityId || !apiPath) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: this.$t('common.error'),
            variant: 'danger',
            text: 'Unable to determine entity type for revert distribution',
          },
        })
        this.$bvModal.hide('modal-redistribution')
        return
      }

      const data = {
        reason: this.redistributionReason || 'Incorrect doctor amount',
      }

      this.params.form = data
      this.params.path = apiPath

      try {
        await this.$store.dispatch('put', this.params)
        this.$bvModal.hide('modal-redistribution')
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: this.$t('common.success'),
            variant: 'success',
            text:
              this.$t('accounting.reDistribution-success')
              || 'Distribution reverted successfully',
          },
        })
        // Refresh data
        this.getDoctorsSurgeries()
        this.getSurgeryConsultancies()
        this.getDoctorPatientStay()
        this.fetchStatistics()
      } catch (error) {
        this.$bvModal.hide('modal-redistribution')
        if (error.response && error.response.status === 400) {
          for (const key in error.response.data) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: this.$t('common.validation-error') || 'Validation Error',
                variant: 'danger',
                text: error.response.data[key][0],
              },
            })
          }
        } else {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: this.$t('common.error'),
              variant: 'danger',
              text:
                error.response?.data?.message
                || this.$t('common.error-occurred')
                || 'An error occurred',
            },
          })
        }
      } finally {
        this.selectedItemForRedistribution = null
        this.redistributionReason = 'Incorrect doctor amount'
      }
    },

    // Payment History Report Methods
    async fetchPaymentHistory() {
      try {
        this.loadingPaymentHistory = true
        this.paymentHistorySummary = null
        this.dailyPaymentSummary = []

        const doctorId = this.$route.params.id
        let url = `/doctor/${doctorId}/daily-payment-summary`
        if (this.historyFrom && this.historyTo) {
          const fromDate = this.formatDate(this.historyFrom)
          const toDate = this.formatDate(this.historyTo)
          url += `?from=${fromDate}&to=${toDate}`
        }

        await this.getList(url)
        console.log(this.all_data, 'this.all_data')

        const data = this.all_data.data || {}

        this.paymentHistorySummary = {
          doctor_id: data.doctor_id,
          doctor_name: data.doctor_name,
          from_date: data.from_date,
          to_date: data.to_date,
          grand_total: data.grand_total || 0,
          total_payments: data.total_payments || 0,
        }

        this.dailyPaymentSummary = Array.isArray(data.daily_summary)
          ? data.daily_summary
          : []
      } catch (error) {
        console.error('Error fetching payment history:', error)
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: this.$t('common.error') || 'خطأ',
            variant: 'danger',
            text:
          (error.response && error.response.data && error.response.data.message)
          || this.$t('common.error-fetching-data')
          || 'حدث خطأ أثناء جلب البيانات',
          },
        })
        this.paymentHistorySummary = null
        this.dailyPaymentSummary = []
      } finally {
        this.loadingPaymentHistory = false
      }
    },

    resetPaymentHistoryFilters() {
      this.historyFrom = null
      this.historyTo = null
      this.paymentHistorySummary = null
      this.dailyPaymentSummary = []
    },
    async viewPaymentHistoryDetail(date) {
      if (!date) return

      this.selectedPaymentDate = date
      this.$bvModal.show('modal-payment-history-detail')
      this.loadingPaymentHistoryDetail = true
      this.paymentHistoryDetailData = []

      try {
        const doctorId = this.$route.params.id
        const from = this.formatDateWithTimeStart(date)
        const to = this.formatDateWithTimeEnd(date)

        const url = `/doctor/${doctorId}/unified-data?page=1&take=10000&types=all&sort=-id&payment_status=1&payment_date_from=${encodeURIComponent(from)}&payment_date_to=${encodeURIComponent(to)}`

        await this.getList(url)

        this.paymentHistoryDetailData = this.all_data.data || []
      } catch (error) {
        console.error('Error fetching payment history detail:', error)
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: this.$t('common.error') || 'خطأ',
            variant: 'danger',
            text:
              (error.response && error.response.data && error.response.data.message)
              || this.$t('common.error-fetching-data')
              || 'حدث خطأ أثناء جلب تفاصيل الدفعات',
          },
        })
        this.paymentHistoryDetailData = []
      } finally {
        this.loadingPaymentHistoryDetail = false
      }
    },
    closePaymentHistoryDetailModal() {
      this.selectedPaymentDate = null
      this.paymentHistoryDetailData = []
    },
    calculateDetailTotalAmount() {
      return this.paymentHistoryDetailData.reduce(
        (sum, item) => sum + parseFloat(item.doctor_price || 0),
        0,
      )
    },
    countActiveDays() {
      if (!Array.isArray(this.dailyPaymentSummary)) return 0
      return this.dailyPaymentSummary.filter(
        day => day.invoices_count > 0,
      ).length
    },
    formatDateTime(value) {
      if (!value) return '-'
      try {
        const d = new Date(value)
        const year = d.getFullYear()
        const month = String(d.getMonth() + 1).padStart(2, '0')
        const day = String(d.getDate()).padStart(2, '0')
        const hours = String(d.getHours()).padStart(2, '0')
        const minutes = String(d.getMinutes()).padStart(2, '0')
        return `${year}-${month}-${day} ${hours}:${minutes}`
      } catch (e) {
        return String(value)
      }
    },
    getDailyRowClass(item) {
      if (!item) return ''
      return item.invoices_count > 0 ? 'table-success' : ''
    },
    printPaymentHistoryDetail() {
      try {
        // Create a new window for printing
        const printWindow = window.open('', '_blank')
        if (!printWindow) {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: this.$t('common.error') || 'خطأ',
              variant: 'warning',
              text:
                this.$t('common.popup-blocked')
                || 'يرجى السماح بالنوافذ المنبثقة',
            },
          })
          return
        }

        // Build HTML content
        const doctorName = this.paymentHistorySummary
          ? this.paymentHistorySummary.doctor_name
          : this.doctorName || '-'
        const paymentDate = this.formatPaymentDate(this.selectedPaymentDate)
        const totalAmount = this.calculateDetailTotalAmount()

        let tableRows = ''
        this.paymentHistoryDetailData.forEach(item => {
          tableRows += `
            <tr>
              <td>${item.patient_name || '-'}</td>
              <td>${this.getTypeLabel(item.type)}</td>
              <td>${this.getSurgeryName(item)}</td>
              <td>${this.formatIQDCurrency(item.total_price || 0)}</td>
              <td>${this.formatIQDCurrency(item.doctor_price || 0)}</td>
              <td>${this.formatDateTime(item.start_time || item.payment_date)}</td>
            </tr>
          `
        })

        const htmlContent = `
<!DOCTYPE html>
<html lang="ar" dir="rtl">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>${this.$t('accounting.payment-history-report') || 'تقرير سجل الدفعات'}</title>
  <style>
    * {
      margin: 0;
      padding: 0;
      box-sizing: border-box;
    }
    body {
      font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
      padding: 20px;
      color: #111827;
      line-height: 1.6;
      font-size: 12px;
    }
    .header {
      text-align: center;
      margin-bottom: 20px;
      border-bottom: 2px solid #333;
      padding-bottom: 10px;
    }
    .header h1 {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 10px;
    }
    .header-info {
      display: flex;
      justify-content: space-between;
      margin-top: 10px;
    }
    .summary {
      margin: 20px 0;
      padding: 15px;
      background: #f9fafb;
      border-radius: 8px;
    }
    .summary-row {
      display: flex;
      justify-content: space-between;
      margin-bottom: 8px;
    }
    table {
      width: 100%;
      border-collapse: collapse;
      margin-top: 20px;
    }
    th, td {
      border: 1px solid #ddd;
      padding: 8px;
      text-align: right;
    }
    th {
      background-color: #f3f4f6;
      font-weight: bold;
    }
    .total-row {
      background-color: #f9fafb;
      font-weight: bold;
    }
    @media print {
      body {
        padding: 10mm;
      }
      table {
        page-break-inside: auto;
      }
      tr {
        page-break-inside: avoid;
      }
    }
  </style>
</head>
<body>
  <div class="header">
    <h1>${this.$t('accounting.payment-history-report') || 'تقرير سجل الدفعات'}</h1>
    <div class="header-info">
      <div>
        <strong>  اسم الطبيب:</strong> ${doctorName}
      </div>
      <div>
        <strong>${this.$t('common.payment-date') || 'تاريخ الدفع'}:</strong> ${paymentDate}
      </div>
    </div>
  </div>

  <div class="summary">
    <div class="summary-row">
      <span><strong>${this.$t('common.total-invoices') || 'إجمالي الفواتير'}:</strong></span>
      <span>${this.paymentHistoryDetailData.length}</span>
    </div>
    <div class="summary-row">
      <span><strong>${this.$t('common.total-amount') || 'المبلغ الإجمالي'}:</strong></span>
      <span>${this.formatIQDCurrency(totalAmount)}</span>
    </div>
  </div>

  <table>
    <thead>
      <tr>
        <th>${this.$t('hospital.patient-name') || 'اسم المريض'}</th>
        <th>${this.$t('common.type') || 'النوع'}</th>
        <th>${this.$t('surgery.surgery-or-service') || 'العملية/الخدمة'}</th>
        <th>${this.$t('common.price') || 'السعر'}</th>
        <th>${this.$t('surgery.doctor_price') || 'مبلغ الطبيب'}</th>
        <th>${this.$t('common.date') || 'التاريخ'}</th>
      </tr>
    </thead>
    <tbody>
      ${tableRows}
    </tbody>
    <tfoot>
      <tr class="total-row">
        <td colspan="4" style="text-align: left;">
          <strong>${this.$t('common.total-amount') || 'المبلغ الإجمالي'}:</strong>
        </td>
        <td colspan="2" style="text-align: right;">
          <strong>${this.formatIQDCurrency(totalAmount)}</strong>
        </td>
      </tr>
    </tfoot>
  </table>

  <script>
    window.onload = function() {
      window.print();
    };
  <${'/'}script>
</body>
</html>
        `

        printWindow.document.write(htmlContent)
        printWindow.document.close()

        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: this.$t('common.success') || 'نجاح',
            variant: 'success',
            text:
              this.$t('common.report-generated')
              || 'تم إنشاء التقرير بنجاح',
          },
        })
      } catch (error) {
        console.error('Error generating report:', error)
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: this.$t('common.error') || 'خطأ',
            variant: 'danger',
            text:
              this.$t('common.error-generating-report')
              || 'حدث خطأ أثناء إنشاء التقرير',
          },
        })
      }
    },
  },
}
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
